@if (text(); as text) {
    <span class="text">{{ text }}</span>
}
<span class="avatar">{{ label() }}</span>
